import React from 'react';
import SelectorCountry from '../selectorCountry';
import SelectorProvince from '../selectorProvince';
import { LocationSelectorProps } from '../interfaces';
import './locationSelector.scss';

const LocationSelector: React.FC<LocationSelectorProps> = ({
  onCountryChange,
  onProvinceChange,
  selectedCountry,
  selectedProvince,
  updateButtonClicked,
}) => {
  const handleCountryChange = (country: string) => {
    onCountryChange(country);
  };

  const handleProvinceChange = (province: string) => {
    onProvinceChange(province);
  };

  return (
    <div className="location-selector">
      <SelectorCountry
        onCountryChange={handleCountryChange}
        selectedCountry={selectedCountry}
        updateButtonClicked={updateButtonClicked}
      />
      <SelectorProvince 
        country={selectedCountry} 
        selectedProvince={selectedProvince} 
        onProvinceChange={handleProvinceChange} 
      />
    </div>
  );
};

export default LocationSelector;














